<template>
  <div
    class="flex-shrink-0 flex-grow-0 d-flex flex-column"
    v-if="$vuetify.breakpoint.smAndUp"
  >
    <slot/>
  </div>
  <v-navigation-drawer
    v-else
    color="cardBg"
    :value="isOpen"
    @input="$emit('update:is-open', $event)"
    absolute
    temporary
  >
    <slot @toggle:collapse="$emit('update:is-open', $event)"/>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "MaterialCategoriesContainer",

  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
}
</script>
